<template>
  <div class="main">
    <Problem :son="21" :questions="questions" />
  </div>
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.ct.one.ll_child.firstQ.question',
          options: [
            { value: 'A', label: 'lang.ct.one.ll_child.firstQ.options.A' },
            { value: 'B', label: 'lang.ct.one.ll_child.firstQ.options.B' },
            { value: 'C', label: 'lang.ct.one.ll_child.firstQ.options.C' },
            { value: 'D', label: 'lang.ct.one.ll_child.firstQ.options.D' },
          ],
          answer: '',
          result: 'D',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.ct.one.ll_child.secondQ.question',
          options: [
            { value: 'A', label: 'lang.ct.one.ll_child.secondQ.options.A' },
            { value: 'B', label: 'lang.ct.one.ll_child.secondQ.options.B' },
            {
              value: 'C',
              label: 'lang.ct.one.ll_child.secondQ.options.C',
            },
            {
              value: 'D',
              label: 'lang.ct.one.ll_child.secondQ.options.D',
            },
          ],
          answer: '',
          result: 'B',
          score: 2,
          scored: 0,
        },
        {
          id: 2,
          question: 'lang.ct.one.ll_child.thirdQ.question',
          options: [
            { value: 'A', label: 'lang.ct.one.ll_child.thirdQ.options.A' },
            { value: 'B', label: 'lang.ct.one.ll_child.thirdQ.options.B' },
            {
              value: 'C',
              label: 'lang.ct.one.ll_child.thirdQ.options.C',
            },
            { value: 'D', label: 'lang.ct.one.ll_child.thirdQ.options.D' },
          ],
          answer: '',
          result: 'C',
          score: 2,
          scored: 0,
        },
        {
          id: 3,
          question: 'lang.ct.one.ll_child.fourthQ.question',
          options: [
            { value: 'A', label: 'lang.ct.one.ll_child.fourthQ.options.A' },
            { value: 'B', label: 'lang.ct.one.ll_child.fourthQ.options.B' },
            { value: 'C', label: 'lang.ct.one.ll_child.fourthQ.options.C' },
            { value: 'D', label: 'lang.ct.one.ll_child.fourthQ.options.D' },
          ],
          answer: '',
          result: 'A',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>